// Shared small helpers used across multiple components.

export function logSupabaseError(context, error) {
  if (error) console.error(`[Supabase] ${context}:`, error.message, error);
}
